import React from "react";
import Modal from 'react-bootstrap/Modal'

import ItemForm from "../item/Form";

import Backend from "../../../utils/Backend";
import Notify from "../../../utils/Notify";
import AuthManager from "../../../utils/AuthManager";
import Form from "../../../utils/Form";

const FORMS = [
  {
    label: "AIS H1",
    value: "ais_h1",
    type: "ais",
    subtype: "H1",
  },
  {
    label: "AIS H7",
    value: "ais_h7",
    type: "ais",
    subtype: "H7",
  },
  {
    label: "AIS G3/G4",
    value: "ais_g3g4",
    type: "ais",
    subtype: "G4G3",
  },
  {
    label: "AES B1",
    value: "aes_B1",
    type: "aes",
    subtype: "B1",
  },
  {
    label: "CDS H1",
    value: "cds_H1",
    type: "cds",
    subtype: "H1",
  },
  {
    label: "CDS B1",
    value: "cds_B1",
    type: "cds",
    subtype: "B1",
  },
  {
    label: "DECO",
    value: "nhd_deco",
    type: "nhd",
    subtype: "H7",
  },
  {
    label: "DMS",
    value: "nhd_dms",
    type: "nhd",
    subtype: "H1",
  },
]

export default class Item extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      show: props.show,
      ...this._getState(props)
    }
  }

  componentDidMount() {
    this._getProduct()
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this._getState(nextProps))
  }

  _getState(props){
    return {
      submission: props.submission,
      productId: props.productId,
      filteredFormType: props.submission?.form?.type || null,
      filteredFormSubType: props.submission?.form?.subtype || null
    }
  }

  _getProduct(){
    let {
      productId
    } = this.state

    if(!productId){
      this.setState({ product: this.state.product || Form.getItemTemplate()})
      return
    }

    Backend.getProduct(productId)
    .then(product => {
      this.setState({product})
    })
    .catch(e => Notify.error(e.message))

  }

  _isFormValid(){
    let {
      product
    } = this.state

    let error = null

    // if(!product.name){
    //   error = "Please enter a name"
    // }else if(!product.description){
    //   error = "Please enter a description"
    // }else if(!product.quantity){
    //   error = "Please enter the quantify"
    // }else if(!product.commodity_code.taric){
    //   error = "Please select a TARIC code"
    // }

    if(error){
      Notify.error(error)
      return false
    }

    return true
  }

  _createProduct(){
    let {
      product,
    } = this.state

    if (!this._isFormValid()) {
      return
    }

    this.setState({loading: true})

    this._handleBackend(product)
    .then(product => {
      Notify.success("Product Saved")
      this.setState({loading: false})
      this.props.onSubmit(product)
    })
    .catch(e => {
      this.setState({loading: false})
      Notify.error(e.message)
    })
  }

  _handleBackend(product){
    if(product.id){
      return Backend.updateProduct(product)
    }
    else{
      return Backend.addProduct(product)
    }
  }

  _updateAuthManager(){
    if(!AuthManager.currentUser.company.onboarding_checklist.item){
      AuthManager.currentUser.company.onboarding_checklist.item = true
    }
  }

  render() {
    let {
      show,
      product,
      loading,
      submission,
      showHiddenFields,
      filteredFormType,
      filteredFormSubType
    } = this.state

    let buttonTitle = this.props.editable ? 'Save Product' : 'Close'

    return (
      <>
        <Modal
          show={show}
          onHide={() => this.props.onHide()}
          className={'sub-modal'}
          dialogClassName={"modal-95"}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title className={"w-100"}>
              { !submission &&
                <div className="row w-100">
                  <div className={"col-10"}>Product</div>
                  <div className={"col-2 text-right"}>
                    <select
                      className="form-select w-100"
                      id="identificationNumberRepresentative"
                      aria-label="Representative Status Code"
                      onChange={e => {
                        const formType= FORMS.find(formType => formType.value === e.target.value)
                        this.setState({
                          filteredFormType: formType?.type,
                          filteredFormSubType: formType?.subtype
                        })
                      }}
                    >
                      <option>Filter to Form</option>
                      { FORMS.map((formType) => {
                        return (
                          <option value={formType.value}>{formType.label}</option>
                        )
                      })}
                    </select>
                  </div>
                </div>
              }
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {product &&
              <ItemForm
                editable={this.props.editable}
                product={product}
                submission={submission}
                filteredFormType={filteredFormType}
                filteredFormSubType={filteredFormSubType}
                showHiddenFields={showHiddenFields}
                onUpdated={product => {
                  this.setState({ product })
                }}
              />
            }


            <div className="row mt-10">
              <div className="col">
                <div className="form-check form-check-custom form-check-solid mt-5">
                  <input
                    className="form-check-input me-3"
                    type="checkbox"
                    checked={showHiddenFields}
                    onChange={e => {
                      showHiddenFields = e.target.checked
                      this.setState({ showHiddenFields })
                    }}
                  />
                  Show Hidden Fields
                </div>
              </div>

              <div className="col text-end">
                <button
                  type="button"
                  className="btn btn-light-primary"
                  disabled={loading}
                  onClick={() => {
                    if(this.props.editable) {
                      this._createProduct()
                    }else {
                      this.props.onHide()
                    }
                  }}
                >
                  {buttonTitle}
                </button>
              </div>
            </div>
          </Modal.Body>

        </Modal>
      </>
    )
  }


}

Item.defaultProps = {
  declaration: true,
  editable: true
}
